import React from "react"
import PropTypes from "prop-types"

import SwaggerUI from "swagger-ui-react"
import "swagger-ui-react/swagger-ui.css"

import "./swagger-json-2020.css"

const Swagger = (props) => {
  return (
    <SwaggerUI url={props.openapiDoc}/>
  )
}

Swagger.propTypes = {
  openapiDoc: PropTypes.string
};

export default Swagger
